import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class RiskTag extends Field {
  static attributesForModel() {
    return ['riskFactorsCount'];
  }

  get title() {
    return 'At risk tag';
  }

  get icon() {
    return 'fa-solid fa-flag';
  }

  exampleContents(): FieldContentsData {
    return {
      pill: {
        text: 'At risk',
        color: 'var(--theme-alert-danger-background)',
        textColor: 'var(--theme-alert-danger-text)',
      },
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (!record.riskFactorsCount) return {};

    return {
      pill: {
        text: 'At risk',
        color: 'var(--theme-alert-danger-background)',
        textColor: 'var(--theme-alert-danger-text)',
      },
    };
  }
}
